import { FormField, Heading } from '@msaf/core-react'
import { TOOLTIP } from '../../../../constants/tooltips'
import LookupField from '../../wells/lookup-field'
import { AquiferEditFormInterface } from './aquifer-test-details-edit'

export default function AquiferTestQualityRatingFormEdit({ fields, isLoading, setValue }: AquiferEditFormInterface) {
  return (
    <>
      <Heading isSkeleton={isLoading} level={3}>
        Quality rating
      </Heading>

      <FormField
        toolTipMessage={TOOLTIP.testRatingId}
        isSkeleton={isLoading}
        label='Test setup and report'
        labelId='testRatingLabel'
      >
        <LookupField
          isSkeleton={isLoading}
          fieldId='testRating'
          labelledBy='testRatingLabel'
          value={`${fields.testRating ?? ''}`}
          setValue={({ value }) => setValue('testRating', value)}
        />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.parameterAccuracyId}
        isSkeleton={isLoading}
        label='Test analysis and parameters'
        labelId='parameterAccuracyLabel'
      >
        <LookupField
          isSkeleton={isLoading}
          fieldId='parameterAccuracy'
          labelledBy='parameterAccuracyLabel'
          value={`${fields.parameterAccuracy ?? ''}`}
          setValue={({ value }) => setValue('parameterAccuracy', value)}
        />
      </FormField>
    </>
  )
}
